module.exports = __webpack_public_path__ + "img/man-torso-front.86ad6ec0.png";